import React from "react";
import './PlanFeatureCards.scss';
import { Check } from "lucide-react";

const PlanFeatureCards = ({ plans }) => {
  if (!plans || !plans.length) return null;
  return (
    <div className="plan-feature-cards">
      <div className="cards-grid">
        {plans.map((plan) => (
          <div key={plan.id} className="plan-card">
            <div className="plan-card-header">
              <h3 className="plan-card-title">{plan.title}</h3>
            </div>
            <ul className="plan-card-list">
              {plan.features.map((f, idx) => {
                if (typeof f === 'object' && f.heading && f.subFeatures) {
                  return (
                    <li key={idx} className="plan-card-item-group">
                      <div className="plan-card-heading">{f.heading}</div>
                      <ul className="plan-card-list">
                        {f.subFeatures.map((subFeature, subIdx) => (
                          <li key={subIdx} className="plan-card-item">
                            <span className="plan-card-icon" aria-hidden="true">
                              <Check className="icon" />
                            </span>
                            <span className="plan-card-text">{subFeature}</span>
                          </li>
                        ))}
                      </ul>
                    </li>
                  );
                }
                return (
                  <li key={idx} className="plan-card-item">
                    <span className="plan-card-icon" aria-hidden="true">
                      <Check className="icon" />
                    </span>
                    <span className="plan-card-text">{f}</span>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlanFeatureCards;


